<div class="update-email-container preference-group group raised-card">
    <h2>Update Email/Username</h2>
    <div>
        <p>Your account was successfully updated!</p>
        <button type="button" class="btn btn-primary" (click)="closeComplete()">OK</button>
    </div>
</div>
